import { getData, postData, putData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

interface ProductOrdersRequest {
  //
}
interface ProductCatalogRequest {
  country: string;
}
export interface ProductOrdersPayload {
  // eslint-disable-next-line camelcase
  overwrite_products: ProductOrders[];
  count: number;
}

export interface ProductCatalogPayload {
  // eslint-disable-next-line camelcase
  overwrite_products: ProductCatalog[];
  count: number;
}

export interface ProductOrders {
  index?: number;
  id: string;
  // eslint-disable-next-line camelcase
  product_id: string;
  // eslint-disable-next-line camelcase
  sold_out: boolean;
  image: string;
  sortOrder: number;
  productName: string;
  maxQty: number;
  participationLevel: string;
  priceColor?: string;
  textColor?: string;
  buttonText?: string;
  buttonTextColor?: string;
  backgroundOpacity?: string;
  buttonPosition?: string;
  buttonBackgroundColor?: string;
  country?: string;
}

export interface ProductCatalog {
  index?: number;
  id: string;
  // eslint-disable-next-line camelcase
  product_id: string;
  image: string;
  brandLogo: string;
  tag: string;
  sortOrder: number;
  productName: string;
  description: string;
  options: string;
  price: string;
  priceDiscount: string;
  country: string;
  status: string;
  link: string;
}

export interface ProductCatalogUpdate {
  id?: string;
  // eslint-disable-next-line camelcase
  product_id?: string;
  link: string;
  brandLogo: string;
  tag: string;
  country: string;
  status?: ProductCatalogStatus;
}

export interface ProductUpdatable {
  // eslint-disable-next-line camelcase
  productName: string;
  maxQty: number;
  priceColor?: string;
  textColor?: string;
  buttonText?: string;
  buttonTextColor?: string;
  backgroundOpacity?: number;
  buttonPosition?: string;
  buttonBackgroundColor?: string;
  country?: string;
}
export interface ProductPayload {
  productId: string;
}
export enum ProductCatalogStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
interface SortHomeWidgetsPayload {
  sortOrderList: {
    id: string;
    productId: string;
    sortOrder: number;
  }[];
  country: string | undefined;
}
interface SuccessResponse {
  success: boolean;
}

export interface SortProductCatalogsPayload {
  sortOrderList: {
    productId: string;
    sortOrder: number;
  }[];
  country: string;
}

export const getProductOrdersRepository = async (requestHeader?: any): Promise<ProductOrders[]> => {
  const response = await getData<ProductOrdersRequest, ProductOrdersPayload>(
    API_URLS.PRODUCT_ORDERS,
    undefined,
    undefined,
    undefined,
    requestHeader,
  );
  return response.data.overwrite_products;
};
export const postSortProductsRepository = async (payload: SortHomeWidgetsPayload): Promise<void> => {
  await postData<SortHomeWidgetsPayload, SuccessResponse>(API_URLS.SORT_PRODUCT_ORDERS, payload);
};
export const postUpdateProductRepository = async (id: string, payload: ProductPayload): Promise<void> => {
  await postData<ProductPayload, SuccessResponse>(API_URLS.UPDATE_PRODUCT_SOLD_OUT, payload);
};
export const getProductFromEcomRepository = async (request?: any): Promise<ProductOrders[]> => {
  const response = await getData<ProductOrdersRequest, ProductOrders[]>(API_URLS.UPDATE_PRODUCT_FROM_ECOM, request);
  return response.data;
};
export const updateProductRepository = async (id: string, payload: ProductUpdatable): Promise<void> => {
  await putData<ProductUpdatable, SuccessResponse>(API_URLS.UPDATE_PRODUCT_OVERWRITE(id), payload);
};

export const getProductCatalogRepository = async (
  requestHeader?: ProductCatalogRequest,
): Promise<ProductCatalogPayload> => {
  const response = await getData<ProductCatalogRequest, ProductCatalogPayload>(
    API_URLS.PRODUCT_CATALOG_DATA_API,
    undefined,
    undefined,
    undefined,
    requestHeader,
  );
  return response.data;
};

export const syncProductCatalogFromEcomRepository = async (
  request?: ProductCatalogRequest,
): Promise<ProductCatalogPayload> => {
  const response = await getData<ProductOrdersRequest, ProductCatalogPayload>(
    API_URLS.PRODUCT_CATALOG_SYNC_API,
    request,
  );
  return response.data;
};

export const postSortProductCatalogsRepository = async (payload: SortProductCatalogsPayload): Promise<void> => {
  await postData<SortProductCatalogsPayload, SuccessResponse>(API_URLS.PRODUCT_CATALOG_SORT_API, payload);
};

export const updateProductCatalogRepository = async (payload: ProductCatalogUpdate): Promise<void> => {
  if (payload?.product_id != null) {
    await putData<ProductCatalogUpdate, SuccessResponse>(
      API_URLS.PRODUCT_CATALOG_UPDATE_API(payload?.product_id),
      payload,
    );
  }
};
